import React, { Component, useRef } from "react";
import { makeStyles, withStyles, useTheme, styled } from '@material-ui/core/styles';
import Save from '../../../../assets/img/svg/save.svg';
import Cancel from '../../../../assets/img/svg/cancel.svg';
import image from "../../../../assets/img/svg/Image.svg"
import docIcon from "../../../../assets/img/svg/docIcon.svg"
import { TextField, InputBase, Radio, RadioGroup, InputAdornment, IconButton, FormControlLabel, Checkbox, FormHelperText } from '@material-ui/core';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import { useNavigate } from "react-router-dom";
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import $ from "jquery";
import Delete from '../../../../assets/img/svg/delete.svg';
import del from "../../../../assets/img/svg/Del.svg"
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import moment from "moment"
import { deletemulitiirdocs, filedeleteDoc, filedeleteirPhoto } from "../../../../actions/InvestigationReportAction";

const useStyles = makeStyles((theme) => ({
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
    error: {
        color: '#f44336',
    },
    helperText: {
        '& p': {
            marginLeft: "0px !important"
        }
    },
    inputfieldAlign: {
        "& fieldset": {
            top: "-1px !important",
        }

    }
}));

const CheckboxWithBlackCheck = withStyles({
    root: {
        "& .MuiSvgIcon-root": {
            fill: "#FFFFFF",
            width: 20,
            height: 20,
            border: "1px solid #000000",
            "&:hover": {
                backgroundColor: "#FFFFFF"
            }
        },
        "&$checked": {
            "& .MuiIconButton-label": {
                position: "relative",
                zIndex: 0,
                backgroundColor: "#FFFFFF",
            },
            "& .MuiIconButton-label:after": {
                content: '""',
                height: 10,
                width: 10,
                position: "absolute",
                backgroundColor: "#000000",
                zIndex: -1
            }
        }
    },
    checked: {}
})(Checkbox);

const BootstrapError = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #f44336',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const names = [
    'Oliver Hansen',
    'Van Henry',
    'April Tucker',
    'Ralph Hubbard',
];

function getStyles(name, personName, theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}

class EditIR_Detail extends Component {
    constructor(props) {
        super(props);
        this.inputFile = React.createRef();
        this.inputPhoto = React.createRef();
        this.state = {
            isView: false,
            isMobile: false,
            state: {
                checkedA: true,
                checkedB: false,
            },
            files: [],
            photos: [],
            ViewDate: "",
            ViewData: [],
            isError: false,
            radio: 'sample',
            filename: "",
            awsname: "",
            Id: 0,
            Error: {
                DateError: false,
                IncidentTypeError: false,
                InvestigationTypeError: false,
            },
            DelIndex: 0,
            addData: {
                "Id": 0,
                "ProjectId": 0,
                "Investigationtype": "",
                "Incidenttype": [],
                "Date": "",
                "Description": "",
                "Comments": "",
            }
        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        window.location.pathname == '/investigationreports/edit' ? this.setState({ isView: false }) : this.setState({ isView: true })
        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.addData.Id = parseInt(localStorage.getItem("IREditId"))
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.UserRole = localStorage.getItem("UserRoles");

        this.setState({})
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
        if (window.location.pathname == "/investigationreports/view") {
            this.state.ViewDate = localStorage.getItem("IRViewId")
            this.setState({})
            this.ViewPage(this.state.ProjectId, this.state.ViewDate);
        } else {
            this.geteditirdocinfo(this.state.addData.Id)
        }
    }
    ViewPage = (id, date) => {
        let apiUrl = API.IR_LISTVIEW + '/' + date;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.ViewData = response.data;
                    this.setState({})
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                }
            });
    };
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#Investigation1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Investigation").removeClass("d-none");
        $("#Investigation").addClass("d-block");
        $("#IRL").addClass("active-color");
        $("#IRT").addClass("fw-bolder");

    };
    componentWillUnmount() {
        clearInterval(this.interval);
        $("#Investigation1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Investigation").addClass("d-none");
        $("#Investigation").removeClass("d-block");
        $("#IRL").removeClass("active-color");
        $("#IRT").removeClass("fw-bolder");
    }
    handleRadio = (event) => {
        this.state.radio = event.target.value
        this.setState({})
    };
    AttachFiles = (e) => {
        this.inputFile.current.click();
    };
    AttachPhoto = (e) => {
        this.inputPhoto.current.click();
    };

    handleInputChange = (e, str) => {
        this.state.addData[str] = e.target.value;
        this.setState({})
        this.props.dispatch({ type: "SHARE_IRDATAS", data: this.state.addData })
    };
    handleChange = (e) => {
        if (e.target.checked == false) {
            if (this.state.addData.Incidenttype.length > 0) {
                this.state.addData.Incidenttype.map((i, ind) => {
                    if (i == e.target.value) {
                        this.state.addData.Incidenttype.splice(ind, 1)
                        this.setState({})
                    }
                })
            }
        }
        else {
            this.state.addData.Incidenttype.push(e.target.value)
            this.setState({})
        }
    }
    geteditirdocinfo = (id) => {
        let apiUrl = API.IR_LISTVIEW + '/' + id;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                  
                    this.state.addData.Id = response.data.Id;
                    this.state.addData.Description = response.data.Description;
                    this.state.addData.Date = response.data?.Date;
                    this.state.addData.Incidenttype = response.data?.Incidenttype;
                    this.state.addData.Investigationtype = response.data?.Investigationtype;
                    // this.state.addData.Investigationtype.map((i,ind)=>{
                    // })
                    if (response.data?.Photos.length > 0) {
                        response.data?.Photos.map((i) => {
                            i.FileName = i.FileName;
                            i.ObjectKey = i.ObjectKey;
                            i.AwsFolderName = i.AwsFolderName;
                            i.AwsUniqueFileName = i.AwsUniqueFileName;
                            i.FileExtention = i.FileExtention;
                            i.FileUrl = i.FileUrl;
                            i.check = false;
                        })
                        this.state.photos = response.data?.Photos;
                    }
                    if (response.data?.Documents.length > 0) {
                        response.data?.Documents.map((i) => {
                            i.FileName = i.FileName;
                            i.ObjectKey = i.ObjectKey;
                            i.AwsFolderName = i.AwsFolderName;
                            i.AwsUniqueFileName = i.AwsUniqueFileName;
                            i.FileExtention = i.FileExtention;
                            i.FileUrl = i.FileUrl;
                            i.check = false;
                        })
                        this.state.files = response.data?.Documents;
                    }
                    let Error = {
                        DateError: false,
                        IncidentTypeError: false,
                        InvestigationTypeError: false,
                    }
                    this.state.Error = Error;
                    this.setState({})
                    this.props.dispatch({ type: "ERROR_IRFILES", data: this.state.Error })
                    this.props.dispatch({ type: "SHARE_IR_ATTACH_FILE", data: this.state.files })
                    this.props.dispatch({ type: "SHARE_IR_ATTACH_PHOTO", data: this.state.photos })
                    this.props.dispatch({ type: "SHARE_IRDATAS", data: this.state.addData })

                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                }
            });
    }
    UploadFile = (e) => {
        Array.from(e.target.files).forEach(async (a) => {
            let upload = {
                FileName: a.name,
                FileSize: a.size,
                check: false,
                fdata: a,
            }
            this.state.files.push(upload)
            this.setState({})
        })
        this.props.dispatch({ type: "SHARE_IR_ATTACH_FILE", data: this.state.files })
    };
    UploadPhoto = (e) => {
        Array.from(e.target.files).forEach(async (a) => {
            let upload = {
                FileName: a.name,
                FileSize: a.size,
                check: false,
                fdata: a,
                base64: await this.toBase64(a),
            }
            this.state.photos.push(upload)
            this.setState({})
        })
        this.props.dispatch({ type: "SHARE_IR_ATTACH_PHOTO", data: this.state.Docs })

    };

    OpenPopup = (filename, awsname, id) => {
        this.state.filename = filename;
        this.state.awsname = awsname;
        this.setState({})
        window.$("#deletepopup").modal("show");
    }
    OpenPopup1 = (filename, awsname, id) => {
        this.state.filename = filename;
        this.state.awsname = awsname;
        this.setState({})
        window.$("#deletepopup").modal("show");
    }
    DeleteItem = () => {
        let tempData = [];
        this.state.files.map((i) => {
            if (i.AwsUniqueFileName == this.state.awsname && this.state.awsname != undefined) {
                this.props.dispatch(filedeleteDoc(this.state.addData.Id, this.state.awsname))
            }
            if (i.FileName != this.state.filename) {
                tempData.push(i)
            }
        })
        this.state.files = tempData;
        this.setState({})
        window.$("#deletepopup").modal("hide");
    }
    DeleteItem1 = () => {
        let tempData = [];
        this.state.photos.map((i) => {
            if (i.AwsUniqueFileName == this.state.awsname && this.state.awsname != undefined) {
                this.props.dispatch(filedeleteirPhoto(this.state.addData.Id, this.state.awsname))
            }
            if (i.FileName != this.state.filename) {
                tempData.push(i)
            }
        })
        this.state.photos = tempData;
        this.setState({})
        window.$("#deletepopup").modal("hide");
    }
    toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
    setCheckbox = (index) => {
        this.state.files.map((i, ind) => {
            if (ind == index) {
                i.check = !i.check;
                this.setState({});
            }
        })
    };
    setCheckbox1 = (index) => {
        this.state.photos.map((i, ind) => {
            if (ind == index) {
                i.check = !i.check;
                this.setState({});
            }
        })
    };

    checkedcheckbox = (i) => {
        let check = this.state.addData.Incidenttype.filter(x => x == i)
        if (check.length > 0) {
            return true;
        }
        else {
            return false;
        }
    }
    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                <div style={{ margin: this.isMobile ? "0" : "15px 30px" }}>
                    <div className="row mt-1 px-3">

                        <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mt-3">
                            <label className="">Investigation <label style={{ whiteSpace: 'nowrap' }}>Type :</label></label>
                        </div>
                        {this.state.isView ?
                            <div className="col-12 col-sm-12 pb-4 col-md-12 col-lg-4 col-xl-4 mt-3">
                                <label>{this.state.ViewData.Investigationtype}</label>
                            </div>
                            :
                            <div className="col-12 col-sm-12 pb-4 col-md-12 col-lg-4 col-xl-4 mt-1">
                                {this.props.errorirpass.Investigationtype ?
                                    <>
                                        <RadioGroup row aria-label="gender" value={this.state.addData.Investigationtype} onChange={(e) => { this.handleInputChange(e, "Investigationtype") }} fullWidth className={classes.error}>
                                            <FormControlLabel value="NearMiss" control={<Radio color="default" className={classes.error} />} label="Near Miss" size="small" />
                                            <FormControlLabel value="Incident" control={<Radio color="default" className={classes.error} />} label="Incident" size="small" />
                                        </RadioGroup>
                                        <FormHelperText className={classes.error}>Required field must be filled in</FormHelperText></>
                                    :
                                    <RadioGroup row aria-label="gender" value={this.state.addData.Investigationtype} onChange={(e) => { this.handleInputChange(e, "Investigationtype") }} fullWidth>
                                        <FormControlLabel value="NearMiss" control={<Radio color="default" />} label="Near Miss" size="small" />
                                        <FormControlLabel value="Incident" control={<Radio color="default" />} label="Incident" size="small" />
                                    </RadioGroup>
                                }
                            </div>
                        }
                        <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mt-3">
                            <label>Date :</label>
                        </div>
                        {this.state.isView ?
                            <div className="col-12 col-sm-12 pb-4 col-md-12 col-lg-4 col-xl-4 mt-3">
                                <label>{this.state.ViewDate && moment(this.state.ViewDate).format("DD-MM-YYYY")}</label>
                            </div>
                            :
                            <div className="col-12 col-sm-12 pb-4 col-md-12 col-lg-4 col-xl-4 mt-3">
                                {this.props.errorirpass.DateError ?
                                    <TextField
                                        type="date"
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.Date && moment(this.state.addData.Date).format("yyyy-MM-DD")}
                                        onChange={(e) => { this.handleInputChange(e, "Date") }}
                                        error
                                        helperText="Required field must be filled in"
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                        classes={{ root: classes.helperText }}
                                    />
                                    :
                                    <TextField
                                        type="date"
                                        value={this.state.addData.Date && moment(this.state.addData.Date).format("yyyy-MM-DD")}
                                        onChange={(e) => { this.handleInputChange(e, "Date") }}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                    />
                                }
                            </div>}
                        <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mt-3">
                                <label>Incident <label style={{ whiteSpace: 'nowrap' }}>Type :</label></label>
                            </div>
                            {this.state.isView ?
                                <div className="col-12 col-sm-12 pb-4 col-md-12 col-lg-10 col-xl-10 mt-3">
                                    <label className="">{this.state.ViewData.Incidenttype}</label>
                                </div>
                                :
                                <div className="col-12 col-sm-12 pb-4 col-md-12 col-lg-10 col-xl-10 mt-3">
                                    {this.props.errorirpass.IncidentTypeError ?
                                        <div className="row " style={{}}>
                                            <div className="pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="Fatalities" checked={this.checkedcheckbox("Fatalities")} onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark1"></span>
                                                </label>
                                                <div className={`${classes.error} ml-5`}>Fatalities</div>
                                            </div>
                                            <div className=" pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="LTI" onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark1"></span>
                                                </label>
                                                <div className={`${classes.error} ml-5`}>LTI</div>
                                            </div>
                                            <div className=" pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="RWC" onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark1"></span>
                                                </label>
                                                <div className={`${classes.error} ml-5`}>RWC</div>
                                            </div>
                                            <div className="pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="FAC" onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark1"></span>
                                                </label>
                                                <div className={`${classes.error} ml-5`}>FAC</div>
                                            </div>
                                            <div className="pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="MTC" onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark1"></span>
                                                </label>
                                                <div className={`${classes.error} ml-5`}>MTC</div>
                                            </div>
                                            <div className="pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="Property Damage" onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark1"></span>
                                                </label>
                                                <div className={`${classes.error} ml-5`}>Property Damage</div>
                                            </div>
                                            <div className="pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="Oil Spill" onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark1"></span>
                                                </label>
                                                <div className={`${classes.error} ml-5`}>Oil Spill</div>
                                            </div>
                                            <div className="pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="Chemical Spill" onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark1"></span>
                                                </label>
                                                <div className={`${classes.error} ml-5`}>Chemical Spill</div>
                                            </div>
                                            <div className=" pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="Gas Leakage" onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark1"></span>
                                                </label>
                                                <div className={`${classes.error} ml-5`}>Gas Leakage</div>
                                            </div>
                                            <div className="pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="Environmental Damage" onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark1"></span>
                                                </label>
                                                <div className={`${classes.error} ml-5`}>Environmental Damage</div>
                                            </div>
                                            <FormHelperText className={classes.error}>Required field must be filled in</FormHelperText>
                                        </div>
                                        :
                                        <div className="row " style={{}}>
                                            <div className="pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="Fatalities" checked={this.checkedcheckbox("Fatalities")} onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark"></span>
                                                </label>
                                                <div className="ml-5">Fatalities</div>
                                            </div>
                                            <div className=" pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="LTI"checked={this.checkedcheckbox("LTI")} onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark"></span>
                                                </label>
                                                <div className="ml-5">LTI</div>
                                            </div>
                                            <div className=" pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="RWC" checked={this.checkedcheckbox("RWC")}onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark"></span>
                                                </label>
                                                <div className="ml-5">RWC</div>
                                            </div>
                                            <div className="pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="FAC" checked={this.checkedcheckbox("FAC")}onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark"></span>
                                                </label>
                                                <div className="ml-5">FAC</div>
                                            </div>
                                            <div className="pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="MTC" checked={this.checkedcheckbox("MTC")}onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark"></span>
                                                </label>
                                                <div className="ml-5">MTC</div>
                                            </div>
                                            <div className="pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="Property Damage" checked={this.checkedcheckbox("Property Damage")}onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark"></span>
                                                </label>
                                                <div className="ml-5">Property Damage</div>
                                            </div>
                                            <div className="pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="Oil Spill" checked={this.checkedcheckbox("Oil Spill")}onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark"></span>
                                                </label>
                                                <div className="ml-5">Oil Spill</div>
                                            </div>
                                            <div className="pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="Chemical Spill" checked={this.checkedcheckbox("Chemical Spill")}onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark"></span>
                                                </label>
                                                <div className="ml-5">Chemical Spill</div>
                                            </div>
                                            <div className=" pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="Gas Leakage" checked={this.checkedcheckbox("Gas Leakage")} onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark"></span>
                                                </label>
                                                <div className="ml-5">Gas Leakage</div>
                                            </div>
                                            <div className="pb-4 col-sm-3 d-flex">
                                                <label class="contCheck">
                                                    <input type="checkbox" value="Environmental Damage" checked={this.checkedcheckbox("Environmental Damage")}onChange={(e) => this.handleChange(e)}></input>
                                                    <span class="checkmark"></span>
                                                </label>
                                                <div className="ml-5">Environmental Damage</div>
                                            </div>
                                        </div>


                                    }
                                </div>}
                        </div>

                        <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mt-3">
                            <label>Description <label style={{ whiteSpace: 'nowrap' }}>:</label></label>
                        </div>
                        {this.state.isView ?
                            <div className="col-12 col-sm-12 pb-4 col-md-12 col-lg-10 col-xl-10 mt-3">
                                <label>{this.state.ViewData.Description}</label>
                            </div>
                            :
                            <div className="col-12 col-sm-12 pb-4 col-md-12 col-lg-4 col-xl-4 mt-3">
                                <TextField
                                    variant="outlined"
                                    multiline
                                    rows={4}
                                    size="small"
                                    fullWidth
                                    value={this.state.addData.Description}
                                    onChange={(e) => { this.handleInputChange(e, "Description") }}
                                    InputProps={{
                                        className: `border-radius ${classes.inputfieldAlign}`
                                    }}
                                />
                            </div>}



                        <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mt-3">
                            <label>Photos :</label>
                        </div>
                        {this.state.isView ?
                            <div className="col-12 col-sm-12 pb-4 col-md-12 col-lg-4 col-xl-4 mt-3">
                                {/* <img src={image} className="pr-2" onClick={PreView} style={{ width: 80, height: 80, cursor: "pointer" }} />
                            <img src={Ship} className="pr-2" onClick={PreView} style={{ width: 80, height: 80, cursor: "pointer" }} />
                        */}
                                {this.state.ViewData.Photos && this.state.ViewData.Photos.map((a) => (
                                    <>
                                        <img src={a.FileUrl} style={{ width: "230px", height: "230px", display: "flex" }} className="pt-2" />
                                    </>
                                ))}
                                <div className="mt-3">
                                </div>
                            </div>
                            :
                            <div className="col-12 col-sm-12 pb-4 col-md-12 col-lg-4 col-xl-4 mt-3">
                                <TextField
                                    disabled
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    placeholder="Browse File"
                                    onChange={(e) => this.UploadPhoto(e)}
                                    accept=".png,.jpg"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment style={{ marginRight: 0 }}>
                                                <IconButton className="rotate p-0" onClick={this.AttachFiles}>
                                                    <AttachFileIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                        className: `border-radius ${classes.inputfieldAlign}`
                                    }}
                                />
                                <input
                                    hidden
                                    type="file"
                                    onChange={(e) => this.UploadPhoto(e)}
                                    accept=".png,.jpg"
                                    ref={this.inputPhoto}
                                />
                                {this.state.photos && this.state.photos.map((i, ind) => {
                                    return (
                                        <div className="row pt-3">
                                            <div className="col-1 col-sm-1 col-lg-1 col-xl-1 col-md-1 pt-1" >
                                                <label class="contCheck">
                                                    <input type="checkbox" checked={i.check} onChange={() => this.setCheckbox1(ind)}  ></input>
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div className="col-1 col-sm-1 col-lg-1 col-xl-1 col-md-1">
                                                <img src={i.FileUrl} style={{ width: 40, height: 40 }} />
                                            </div>
                                            <div className="col-9 col-sm-9 col-lg-9 col-xl-9 col-md-9 pl-4" >
                                                <label className="fw-700  word-break">{i.FileName}<br></br><label style={{ color: "#B0AAAA" }}>{(i.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></label>
                                            </div>
                                            {i.check == true ?
                                                <div className="col-1 col-sm-1 col-lg-1 col-xl-1 col-md-1 pt-1 pt-2 pl-0 pr-0 mr-0 space">
                                                    <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup1(i.FileName, i.AwsUniqueFileName, i.Id) }} />
                                                </div> : <></>}
                                        </div>
                                    )
                                })}
                            </div>
                        }
                        {this.state.isView ? <></> : <>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mt-3">
                                <label>Documents <label style={{ whiteSpace: 'nowrap' }}>:</label></label>
                            </div>
                            <div className="col-12 col-sm-12 pb-4 col-md-12 col-lg-4 col-xl-4 mt-3">
                                <TextField
                                    disabled
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    accept=".pdf"
                                    onChange={(e) => { this.UploadFile(e) }}
                                    placeholder="Browse File"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment className="mr-0">
                                                <IconButton className="rotate p-0" onClick={this.AttachFiles}>
                                                    <AttachFileIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                        className: `border-radius ${classes.inputfieldAlign}`
                                    }}
                                />
                                <input
                                    hidden
                                    type="file"
                                    accept=".pdf"
                                    onChange={(e) => { this.UploadFile(e) }}
                                    ref={this.inputFile}
                                />
                                {this.state.files && this.state.files.map((m, i) => (
                                    <div className="row pt-3">
                                        <div className="col-1 col-sm-1 col-lg-1 col-xl-1 col-md-1 pt-1">
                                            <label class="contCheck">
                                                <input type="checkbox" checked={m.check} onChange={() => this.setCheckbox(i)} ></input>
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                        <div className="col-1 col-sm-1 col-lg-1 col-xl-1 col-md-1">
                                            <img src={docIcon} />
                                        </div>
                                        <div className="col-9 col-sm-9 col-lg-9 col-xl-9 col-md-9 pl-4" >
                                            <label className="fw-700">{m.FileName}<br></br><label style={{ color: "#B0AAAA" }}>{(m.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></label>
                                        </div>
                                        {m.check == true ?
                                            <div className="col-1 col-sm-1 col-lg-1 col-xl-1 col-md-1 pt-1 pt-2 pl-0 pr-0 mr-0 space">
                                                <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(m.FileName, m.AwsUniqueFileName, m.Id) }} />
                                            </div> : <></>}
                                    </div>
                                ))}
                            </div>
                        </>
                        }
                        {this.state.isView ? <></> : <>
                            <div className="row mr-0 pr-0">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mt-3">
                                    <label>Comments :</label>
                                </div>
                                <div className="col-12 mt-3 col-sm-12 pb-4 col-md-12 col-lg-10 col-xl-10 mr-0 pr-0">
                                    <TextField
                                        multiline
                                        rows={8}
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.Comments}
                                        onChange={(e) => { this.handleInputChange(e, "Comments") }}

                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                    />
                                </div>
                            </div>
                        </>
                        }

                    </div>

                </div>
                {/* <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel" style={{ display: preview ? "none" : "", marginTop: isMobile ? 50 : -300, width: isMobile ? "auto" : "1040px", background: "#FFFFFF", marginLeft: isMobile ? 0 : -54 }} >
                <div class="carousel-indicators">
                    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
                    <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
                </div>
                <div className="row">
                    <div className="col-12 col-sm-12  text-end">
                        <Close onClick={CloseSlider} className="p-2" style={{ width: "40px", height: "40px", cursor: "pointer" }} />
                    </div>
                </div>
                <div class="carousel-inner" >
                    <div class="carousel-item active">
                        <img src={image} style={{ width: isMobile ? "auto" : "400px", height: "400px" }} class="d-block w-100" alt="..." />
                        <div class="carousel-caption d-none d-md-block">
                            <h5 style={{ color: "#FFFFFF" }}>Image</h5>
                        </div>
                    </div>
                    <div class="carousel-item">
                        <img src={Ship} style={{ width: isMobile ? "auto" : "400px", height: "400px" }} class="d-block w-100" alt="..." />
                        <div class="carousel-caption d-none d-md-block">
                            <h5 style={{ color: "#000000" }}>Ship</h5>
                        </div>
                    </div>
                </div>
                <button class="carousel-control-prev my-5" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon black" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next  my-5 " type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                </button>
            </div> */}
                <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" data-dismiss="modal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="deletepopup1" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" data-dismiss="modal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem1()}><span className="" >Delete</span></button>
                                <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        geteditir: state.IRReducer.geteditir || [],
        sharedirattachfile: state.IRReducer.sharedirattachfile || [],
        sharedirattachphoto: state.IRReducer.sharedirattachphoto || [],
        sharedirdata: state.IRReducer.sharedirdata || [],
        errorirpass: state.IRReducer.errorirpass || [],

    };
}

EditIR_Detail.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EditIR_Detail))
);
